module.exports = __webpack_public_path__ + "img/development_news_title2.a80b164a.png";